<template>
	<div v-if="viewingItem" @click="close">
		<div class="item-viewer--content">
			<div class="item-viewer--item-info">
				<h3 class="tertiary-heading">{{ selectedItem.name }}</h3>
				<h4 class="primary-copy">${{ selectedItem.price }}</h4>
				<h4 class="primary-copy" v-if="selectedItem.desc !== selectedItem.name">{{ selectedItem.desc }}</h4>
			</div>
			<form class="item-viewer--item-data" @submit.prevent>
				<div class="item-data--top">
					<label class="primary-copy" for="specialInstructions">Special Instructions</label>
					<textarea class="primary-copy special-instructions" name="specialInstructions" id="specialInstructions" cols="50" rows="4" v-model="specialInstructions"></textarea>
				</div>
				<div class="item-data--bottom">
					<div class="item-data--quantity-control">
						<a @click="decrement"><i class="fa fa-minus"></i></a>
						<input type="text" id="quantity" v-model="selectedItem.qty" disabled>
						<a @click="increment"><i class="fa fa-plus"></i></a>
					</div>
					<button class="item-data--submit" @click="handleAddItem">{{ editOrAdd }}</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ItemViewer',
		props: ['selectedItem', 'viewingItem'],
		data () {
			return {
				specialInstructions: ''
			}
		},
		computed: {
			editOrAdd () {
				if (this.selectedItem.edit) {
					return 'Update Item'
				}
				return 'Add Item'
			}
		},
		methods: {
			increment () {
				this.$emit('addOne')
			},
			decrement () {
				if (this.selectedItem.qty !== 1) {
					this.$emit('subtractOne')
				}
			},
			handleAddItem () {
				this.$emit('addItem', this.specialInstructions)
				this.$emit('close', this.selectedItem.edit)
				this.quantity = 1
				this.specialInstructions = ''
			},
			close (e) {
				if (e.target.classList.contains('item-viewer')) {
					this.$emit('close')
					this.quantity = 1
					this.specialInstructions = ''
				}
			}
		}
	}
</script>

<style lang='scss' scoped>
	@import '../assets/css/main';

	.item-viewer {
		background: linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) );
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		.item-viewer--content {
			background: $secondary-color;
			padding: 2%;
			position: relative;
			width: 40%;
			@media (max-width: 500px) {
				max-width: 85%;
			}
		}
	}

	.item-viewer--item-info {
		.tertiary-heading, .primary-copy {
			// margin-bottom: 5%;
		}
		.tertiary-heading {
			color: $primary-color;
		}
		.primary-copy {
			color: white;
		}
	}

	.item-viewer--item-data {
		display: flex;
		flex-direction: column;
		.primary-copy {
			color: white;
			margin-bottom: 2%;
		}
		.special-instructions {
			color: black;
		}
		.item-data--top {
			display: flex;
			flex-direction: column;
			margin-bottom: 5%;
		}
		.item-data--bottom {
			display: flex;
			justify-content: space-between;
		}
		.item-data--submit {
			@include primary-button($primary-color);
			@include primary-font(2.4rem, 400);
			color: $primary-color;
			background-color: white;
			width: 50%;
		}
	}

	.item-data--quantity-control {
		width: 50%;
		display: flex;
		justify-content: flex-start;
		a:hover {
			cursor:pointer;
			opacity: 0.5;
		}
		a {
			color: white;
			margin-top: 15px;
			@include primary-font(2.4rem, 400);
			text-align: center;
			border: none !important;
		}
		input {
			appearance: none;
			background: $secondary-color;
			border: none !important;
			color: white;
			@include primary-font(4rem, 400);
			width: 25%;
			text-align: center;
		}
	}

</style>


// WEBPACK FOOTER //
// src/components/ItemViewer.vue